export const successCodeRegex = /2[0-9][0-9]/;
